<template>
  <div class="search-form">
    <div class="d-flex">
      <div style="width:400px;" class="mb-2">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            placeholder="运单编号/合同名称/承运商名称/司机姓名/创建人搜索..."
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  高级搜索
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="mb-2">
        <b-input-group size="sm">
          <b-button
            v-allow="'actBuilder'"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="batchSumit()"
            >生成账单
          </b-button>
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="$emit('batchCancel')"
          >
            批量回退
          </b-button>
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            v-allow="'actExport'"
            @click="$emit('batchExport')"
          >
            <i class="el-icon-folder-opened"></i>
            批量导出
          </b-button>
        </b-input-group>
      </div>
    </div>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
          <el-form-item label="运单编号">
            <el-input
              v-model.trim="form.waybillNo"
              placeholder="请输入运单编号"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="结算单生成时间">
            <el-date-picker
              v-model="form.settlementBuildTime"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="始发地省份">
            <el-input
              v-model.trim="form.originProvinceName"
              placeholder="请输入始发地省份"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="始发地发货方">
            <el-input
              v-model.trim="form.originName"
              placeholder="请输入始发地发货方"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="实际提货时间">
            <el-date-picker
              v-model="form.pickDateTime"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="目的地省份">
            <el-input
              v-model.trim="form.destinationProvinceName"
              placeholder="请输入目的地省份"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="目的地收货方">
            <el-input
              v-model.trim="form.destinationName"
              placeholder="请输入目的地收货方"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="实际到货时间">
            <el-date-picker
              v-model="form.receiveDateTime"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="应收账款状态">
            <el-checkbox-group v-model="form.payFreightStatusList">
              <el-checkbox label="N">未处理</el-checkbox>
              <el-checkbox label="D">已取消</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  payFreightStatusList: [],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      let listStatus = this.form.payFreightStatusList || []
      if (!listStatus.length) listStatus = ['N', 'D']
      this.$emit('query', { ...this.form, payFreightStatusList: listStatus })
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    batchSumit() {
      this.$emit('batchSumit')
    },
  },
}
</script>
